import { Link } from "react-router-dom";

export const LOGO_URL = "https://customer-assets-v7afamib.emergentagent.net/job_payroll-manager-190/artifacts/pyllm9aj_ChatGPT%20Image%20Aug%205%2C%202026%2C%2001_57_51%20PM.png";

const SIZES = {
  xs: "h-8",
  sm: "h-10",
  md: "h-14",
  lg: "h-20",
  xl: "h-28",
};

/**
 * Premium brand mark for HG Consultancy — Payroll Servicing.
 * Use `variant="light"` on cream backgrounds, `variant="dark"` on dark backgrounds.
 */
export function Brand({ size = "sm", variant = "light", asLink = false, className = "", showTagline = false }) {
  const cls = `${SIZES[size]} w-auto ${variant === "dark" ? "drop-shadow-[0_0_18px_rgba(201,169,97,0.35)]" : ""}`;
  const body = (
    <div className={`flex items-center gap-3 ${className}`}>
      <img src={LOGO_URL} alt="HG Consultancy — Payroll Servicing" className={cls} data-testid="brand-logo-img" />
      {showTagline && (
        <div className="hidden sm:block leading-none">
          <div className={`font-serif italic text-[11px] tracking-widest ${variant === "dark" ? "text-[#D4B87D]" : "text-[#8C6F1E]"}`}>Est. Harguaon Group</div>
        </div>
      )}
    </div>
  );
  if (asLink) return <Link to="/" data-testid="brand-logo" className="inline-flex">{body}</Link>;
  return body;
}

/** Compact wordmark for tight sidebar chrome where the logo would be too tall. */
export function BrandText({ variant = "light" }) {
  const isDark = variant === "dark";
  return (
    <div>
      <div className={`font-serif font-black text-2xl tracking-tight ${isDark ? "text-white" : "text-neutral-950"}`} data-testid="brand-text">
        HG <span className="text-[#C9A961]">Consultancy</span>
      </div>
      <div className={`mt-1 text-[9px] font-mono uppercase tracking-[0.3em] ${isDark ? "text-[#D4B87D]" : "text-[#8C6F1E]"}`}>
        Payroll Servicing
      </div>
    </div>
  );
}
